import type { ActionsObservable } from 'redux-observable';
import 'rxjs/add/operator/map';
import isEmpty from 'lodash/isEmpty';
import type { Observable } from 'rxjs/Observable';
import { SET_RELATED_ISSUES_COUNT, deleteVersion, showDialog } from '../../state/actions.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>): Observable<any> =>
	action$.ofType(SET_RELATED_ISSUES_COUNT).map((action) => {
		const relatedIssues = action.payload;
		if (isEmpty(relatedIssues)) {
			return deleteVersion();
		}
		return showDialog();
	});
